// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_info__O-L9s {
  font-size: 12px;
  margin: 20px 0;
  color: #9c9c9c;
}

.styles_divisor__6xiiB {
  border-bottom: 1px solid #9c9c9c;
  margin: 20px 0;
}

.styles_title__6DABh {
  font-size: 16px;
  margin: 20px 0;
}

.styles_logoWrapper__d\\+0n\\+ {
  display: grid;
  align-items: center;
}

.styles_btnLogo__G5tET {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: green;
  color: white;
  height: 35px;
  width: 100px;
  border-radius: 3px;
  cursor: pointer;
}

.styles_modal__rT8-g {
  display: grid;
  justify-content: center;
}

.styles_wrapperLogo__4DC-t {
  display: flex;
  gap: 40px;
  padding: 20px;
}
.styles_wrapperLogo__4DC-t h4 {
  text-align: center;
  font-size: 14px;
}

.styles_gridImage__BpRYa {
  border: 1px solid grey;
  height: 250px;
  width: 250px;
}
.styles_gridImage__BpRYa img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.styles_fileUpload__R6c4e {
  position: relative;
}

.styles_fileUpload__R6c4e input[type=file] {
  position: absolute;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 30px;
  cursor: pointer;
}

.styles_remove__pgQOU {
  background-color: rgb(243, 62, 62);
  color: white;
  font-size: 14px;
  width: 100%;
  height: 30px;
}

.styles_fileUpload__R6c4e button {
  background-color: green;
  color: white;
  font-size: 14px;
  width: 100%;
  height: 30px;
}

.styles_btnWrapper__onLwH {
  display: flex;
  justify-content: space-between;
  margin: 0 50px;
}`, "",{"version":3,"sources":["webpack://./src/Components/data/modalImage/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;AACJ;;AAGA;EACE,sBAAA;EACA,aAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,kCAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AADF","sourcesContent":[".info {\n  font-size: 12px;\n  margin: 20px 0;\n  color: #9c9c9c;\n}\n\n.divisor {\n  border-bottom: 1px solid #9c9c9c;\n  margin: 20px 0;\n}\n\n.title {\n  font-size: 16px;\n  margin: 20px 0;\n}\n\n.logoWrapper {\n  display: grid;\n  align-items: center;\n}\n\n.btnLogo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: green;\n  color: white;\n  height: 35px;\n  width: 100px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.modal {\n  display: grid;\n  justify-content: center;\n}\n\n.wrapperLogo {\n  display: flex;\n  gap: 40px;\n  padding: 20px;\n\n  h4 {\n    text-align: center;\n    font-size: 14px;\n  }\n}\n\n.gridImage {\n  border: 1px solid grey;\n  height: 250px;\n  width: 250px;\n\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.fileUpload {\n  position: relative;\n}\n\n.fileUpload input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n}\n\n.remove {\n  background-color: rgb(243, 62, 62);\n  color: white;\n  font-size: 14px;\n  width: 100%;\n  height: 30px;\n}\n\n.fileUpload button {\n  background-color: green;\n  color: white;\n  font-size: 14px;\n  width: 100%;\n  height: 30px;\n}\n\n.btnWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `styles_info__O-L9s`,
	"divisor": `styles_divisor__6xiiB`,
	"title": `styles_title__6DABh`,
	"logoWrapper": `styles_logoWrapper__d+0n+`,
	"btnLogo": `styles_btnLogo__G5tET`,
	"modal": `styles_modal__rT8-g`,
	"wrapperLogo": `styles_wrapperLogo__4DC-t`,
	"gridImage": `styles_gridImage__BpRYa`,
	"fileUpload": `styles_fileUpload__R6c4e`,
	"remove": `styles_remove__pgQOU`,
	"btnWrapper": `styles_btnWrapper__onLwH`
};
export default ___CSS_LOADER_EXPORT___;
